// ==================================== Thumbnail Added =======================================

import React, { useState } from "react";

const PostMedia = ({
    post,
    BASE_URL,
    onImageClick,
    onVideoPlay,
    videoRefs,
    handlers,
    countRatio = 4,
    separator = 3,
    isRevolution = false,
}) => {
    // tracks whether the user has clicked to load the real video
    const [videoLoaded, setVideoLoaded] = useState(false);

    /* IMAGE */
    if (post.images?.length > 0) {
        const remaining = post.images.length - countRatio;

        return (
            <div className={`post-image-grid grid-${Math.min(post.images.length, countRatio)}`}>
                {post.images.slice(0, countRatio).map((img, index) => {
                    const isSingle = post.images.length === 1;

                    // show the lightweight thumbnail first, fall back to
                    // the original image if no thumbnail was generated
                    const thumbSrc =
                        post.imageThumbnails?.[index] || img;

                    return (
                        <div
                            key={index}
                            className={`prime-image-wrapper ${isSingle ? "single-image" : "multi-image"
                                }`}
                            onClick={() => handlers.openImage(post.images)}
                        >
                            <img
                                src={`${thumbSrc.replace(/\\/g, "/")}`}
                                className="post-image"
                                alt="post"
                                loading="lazy"
                            />

                            {index === separator && remaining > 0 && (
                                <div className="more-overlay">+{remaining}</div>
                            )}
                        </div>
                    );
                })}
            </div>
        );
    }

    /* VIDEO */
    if (post.video && !isRevolution) {
        const videoSrc = `${post.video.replace(/\\/g, "/")}`;
        const thumbSrc = post.videoThumbnail
            ? `${post.videoThumbnail.replace(/\\/g, "/")}`
            : null;

        // No thumbnail available — just render the real video as before
        if (!thumbSrc) {
            return (
                <video
                    src={videoSrc}
                    className="post-video"
                    controls
                    muted
                    playsInline
                    onPlay={(e) => onVideoPlay?.(e.target)}
                    ref={(el) => {
                        if (!videoRefs) return;
                        if (el) videoRefs.current.set(post._id, el);
                        else videoRefs.current.delete(post._id);
                    }}
                />
            );
        }

        // Show thumbnail + play button until the user clicks
        if (!videoLoaded) {
            return (
                <div
                    className="post-video-thumb-wrapper"
                    style={{
                        position: "relative",
                        cursor: "pointer",
                        background: "#000",
                        borderRadius: "8px",
                        overflow: "hidden",
                    }}
                    onClick={() => setVideoLoaded(true)}
                >
                    <img
                        src={thumbSrc}
                        alt="video thumbnail"
                        className="post-video"
                        style={{
                            width: "100%",
                            display: "block",
                            opacity: 0.9,
                        }}
                        loading="lazy"
                    />

                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "68px",
                            height: "48px",
                            background: "rgba(0,0,0,0.6)",
                            borderRadius: "12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <div
                            style={{
                                width: 0,
                                height: 0,
                                borderTop: "12px solid transparent",
                                borderBottom: "12px solid transparent",
                                borderLeft: "20px solid white",
                                marginLeft: "4px",
                            }}
                        />
                    </div>
                </div>
            );
        }

        // User clicked — load and play the real video
        return (
            <video
                src={videoSrc}
                className="post-video"
                controls
                autoPlay
                muted
                playsInline
                onPlay={(e) => onVideoPlay?.(e.target)}
                ref={(el) => {
                    if (!videoRefs) return;
                    if (el) videoRefs.current.set(post._id, el);
                    else videoRefs.current.delete(post._id);
                }}
            />
        );
    }

    return null;
};

export default PostMedia;



// ================================= Without Thumbnail ============================================================


// const PostMedia = ({
//     post,
//     BASE_URL,
//     onImageClick,
//     onVideoPlay,
//     videoRefs,
//     handlers,
//     countRatio = 4,
//     separator = 3,
//     isRevolution = false,
// }) => {

//     /* IMAGE */
//     if (post.images?.length > 0) {
//         const remaining = post.images.length - countRatio;

//         return (
//             <div className={`post-image-grid grid-${Math.min(post.images.length, countRatio)}`}>
//                 {post.images.slice(0, countRatio).map((img, index) => {
//                     const isSingle = post.images.length === 1;

//                     return (
//                         <div
//                             key={index}
//                             className={`prime-image-wrapper ${isSingle ? "single-image" : "multi-image"
//                                 }`}
//                             onClick={() => handlers.openImage(post.images)}
//                         >
//                             <img
//                                 src={`${img.replace(/\\/g, "/")}`}

//                                 className="post-image"
//                                 alt="post"
//                             />

//                             {index === separator && remaining > 0 && (
//                                 <div className="more-overlay">+{remaining}</div>
//                             )}
//                         </div>
//                     );
//                 })}
//             </div>
//         );
//     }

//     /* VIDEO */
//     if (post.video && !isRevolution) {
        
//         return (
//             <video
//                 src={`${post.video.replace(/\\/g, "/")}`}
//                 className="post-video"
//                 controls
//                 muted
//                 playsInline
//                 onPlay={(e) => onVideoPlay?.(e.target)}
//                 ref={(el) => {
//                     if (!videoRefs) return;
//                     if (el) videoRefs.current.set(post._id, el);
//                     else videoRefs.current.delete(post._id);
//                 }}
//             />
//         );
//     }

//     return null;
// };

// export default PostMedia;